export default __webpack_public_path__ + "static/media/ic_history.885acfaf.svg";